import { Injectable, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NativeDateAdapter } from '@angular/material/core';
import { LocaleService, LocaleEnum } from 'library-explorer';

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  private readonly localeService = inject(LocaleService);

  constructor() {
    super();
    this.localeService.locale
      .pipe(
        takeUntilDestroyed(inject(DestroyRef))
      )
      .subscribe(locale => {
        this.setLocale(locale === LocaleEnum.US ? 'en-US' : 'en-GB');
      });
  }

  override getFirstDayOfWeek(): number {
    return 1;
  }
}
